var Queue = /** @class */function () {
  function Queue() {
    var _this = this;
    this.queueList = {};
    this.add = function (url, callback) {
      _this.queueList[url] = _this.queueList[url] || [];
      _this.queueList[url].push(callback);
    };
    this.run = function (url) {
      var _loop_1 = function _loop_1(i, len) {
        // 异步触发回调，防止阻塞UI渲染
        setTimeout(function () {
          if (Array.isArray(_this.queueList[url])) {
            var cacheValue = _this.cache.get(url);
            var callback = _this.queueList[url][i];
            if (cacheValue instanceof Error) {
              callback(cacheValue);
            } else if (cacheValue) {
              callback(null, cacheValue);
            }
            if (i === _this.queueList[url].length - 1) {
              delete _this.queueList[url];
            }
          }
        }, 0);
      };
      for (var i = 0, len = _this.queueList[url].length; i < len; i++) {
        _loop_1(i, len);
      }
    };
    this.remove = function () {
      _this.queueList = {};
    };
    this.cache = new Map();
  }
  return Queue;
}();
export default Queue;